module.exports = __webpack_public_path__ + "static/img/areaB_08.7d92547.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/areaB_08.png
// module id = 1260
// module chunks = 1